module.exports = g_errstrBase;